import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import { applyTextStyle } from '../../styles/typography'
import { Icon } from '../icon'

interface IProps {
  message: string
  clearLabel: string
  onClear: () => void
}

const FilterEmptyState: React.FC<IProps> = ({
  message,
  clearLabel,
  onClear,
}) => {
  const theme = useContext(ThemeContext)
  return (
    <Wrapper>
      <Icon type="Search" size={20} color={theme.colors.textLight} />
      <Message>{message}</Message>
      <ClearLink type="button" onClick={onClear}>
        {clearLabel}
      </ClearLink>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  text-align: center;
`

const Message = styled.span`
  margin-top: 12px;
  color: ${({ theme }) => theme.colors.text};
  ${applyTextStyle('label')}
`

const ClearLink = styled.button`
  margin-top: 4px;
  padding: 0;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  ${applyTextStyle('label')}
  text-decoration: underline;
`

export default FilterEmptyState
